<template>
  <el-form>
    <div v-if="data.length > 0" :class="{ 'on-mobile':  $store.state.chat.isMobileMode }" class="fix-mobile">
      <div class="form-element-tag" v-for="month in data" :key="month.mouths">
        <el-tag>{{ month.mouths }}</el-tag>
        <el-checkbox-group v-model="checklist" @change="fnClick(data, $event)">
          <el-checkbox
            :label="range.date + ' ' + month.mouths"
            :name="range.key"
            v-for="range in month.ranges"
            :key="range.key"
            border
          ></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <h4 style="color: #00978b" v-if="data.length == 0">
      <p  class="text-center">ไม่พบโปรแกรมทัวร์ที่ค้นหา </p>
    </h4>
    <br />
  </el-form>
</template>

<script>
import { Tag, Form, Checkbox, CheckboxGroup, Button, Row,Col } from 'element-ui';
import { map } from 'lodash';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      result: [],
      checklist: [],
    };
  },
  components: {
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]:Col
  },
  methods: {
    fnClick(month, checked) {
      this.result = [];
      checked.forEach(date => {
        const d = date.split(' ');
        const m = d[1];
        const r = d[0];
        month.forEach(v => {
          if (v.mouths == m) {
            const c = v.ranges.filter(g => {
              return g.date == r;
            });
            this.result = map(c[0].items, function(val) {
              return val.id;
            });
          }
        });
      });
    },
    clear() {
      this.checklist = [];
    },
  },
  watch: {
    result: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.$store.dispatch('chat/setPeriodProductSearch', val);
        } else {
          this.$store.dispatch('chat/setPeriodProductSearch', []);
        }
      },
    },
  },
};
</script>
<style>
.el-checkbox.is-bordered {
  padding: 9px 10px 9px 10px;
}
.form-element-tag span.el-tag {
  cursor: unset;
  padding: 0 12px;
  height: 40px;
  line-height: 38px;
  font-size: 20px;
  margin-bottom: 8px;
  margin-right: 5px;
  background: #00978bd4;
  color: #fff;
}
.form-element-tag {
  display: inline-flex;
  width: 495px;
}
.el-checkbox__label {
  font-size: 18px;
}
.fix-mobile.on-mobile {
  max-height: 185px;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/listProductSearch.vue